import { Sex } from "./UserData";

export class ClimbingEventRoutesResults {
    constructor(
        public sex: Sex,
        public userRoutes: Map<string, UserRoutes> = new Map<string, UserRoutes>(),
    ) {
    }
    toJSON(){
        return {
            sex: this.sex,
            userRoutes: Object.fromEntries(this.userRoutes),
        }
     }
}


export type UserRoutes = {
    zones: string
    zones_2: string
    top: string
    flash: string
    userId: string
}